import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = { class: "page-container card col-md-8" }
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "row p-3" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "row p-3 pb-0" }, [
  /*#__PURE__*/_createElementVNode("label", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Search existing User by:")
  ])
], -1)
const _hoisted_10 = { class: "row p-3 pb-0" }
const _hoisted_11 = { class: "col-md-4" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "col-md-9" }
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "col-md-9" }
const _hoisted_21 = { class: "row p-3 pb-0" }
const _hoisted_22 = { class: "col-md-4" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "row p-3" }
const _hoisted_25 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_27 = { class: "col-md-7" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-12 p-4" }
const _hoisted_30 = { class: "p-datatable p-component p-datatable-hoverable-rows align-middle mb-0 w-12" }
const _hoisted_31 = { class: "p-datatable-thead" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"8%"} }, "#", -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }, "Role ", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"12%"} }, "Status", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("th", { style: {"width":"5%"} }, null, -1)
const _hoisted_36 = {
  key: 0,
  class: "p-datatable-tbody"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = {
  key: 0,
  class: "error-no-record"
}
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_TheTableLoading = _resolveComponent("TheTableLoading")!
  const _component_TheInvalidImportDialog = _resolveComponent("TheInvalidImportDialog")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ThePageHeader, {
                onImportEvent: _ctx.importFile,
                onExportEvent: _ctx.exportFile,
                renderImport: !_ctx.isLoading,
                renderExport: !_ctx.isLoading,
                isImporting: _ctx.isImporting,
                isExporting: _ctx.isExporting
              }, null, 8, ["onImportEvent", "onExportEvent", "renderImport", "renderExport", "isImporting", "isExporting"]),
              (_ctx.pageError == '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _ctx.add,
                          label: "Create New User"
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_InputText, {
                          class: "p-inputtext",
                          type: "text",
                          maxlength: "50",
                          placeholder: "Name",
                          modelValue: _ctx.filterNameModel.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterNameModel.value) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_InputText, {
                          class: "p-inputtext",
                          type: "text",
                          maxlength: "50",
                          placeholder: "Email Address",
                          modelValue: _ctx.filterEmailAddressModel.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filterEmailAddressModel.value) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.companies,
                          optionLabel: "code",
                          optionValue: "identifier",
                          filter: "",
                          filterFields: ['code', 'name'],
                          showClear: "",
                          placeholder: _ctx.isCompanyLoading ? ('Loading...') : 'Company',
                          loading: _ctx.isCompanyLoading,
                          modelValue: _ctx.filterCompanyModel.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterCompanyModel.value) = $event))
                        }, {
                          value: _withCtx((slotProps) => [
                            (slotProps.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.filterCompanyCodeByValue(slotProps.value)), 1),
                                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.filterCompanyNameByValue(slotProps.value)), 1)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(slotProps.placeholder), 1))
                          ]),
                          option: _withCtx((slotProps) => [
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("span", _hoisted_19, _toDisplayString(slotProps.option.code), 1),
                              _createElementVNode("span", _hoisted_20, _toDisplayString(slotProps.option.name), 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["options", "placeholder", "loading", "modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.getUserStatuses(_ctx.statuses),
                          optionLabel: "name",
                          optionValue: "value",
                          placeholder: "Status",
                          modelValue: _ctx.filterStatusModel.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterStatusModel.value) = $event))
                        }, null, 8, ["options", "modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_Dropdown, {
                          options: _ctx.filterUserRoles,
                          optionLabel: "name",
                          optionValue: "value",
                          placeholder: "Role",
                          modelValue: _ctx.filterUserRoleModel.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterUserRoleModel.value) = $event)),
                          display: "chip",
                          onChange: _ctx.resetCompanies,
                          disabled: !_ctx.isAdmin && _ctx.userRole == 'Admin'
                        }, null, 8, ["options", "modelValue", "onChange", "disabled"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createVNode(_component_Button, {
                          class: "p-button-sm",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.find(1))),
                          label: "Search"
                        }),
                        _hoisted_26,
                        _createVNode(_component_Button, {
                          class: "p-button-sm p-button-secondary",
                          onClick: _ctx.reset,
                          label: "Reset"
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        (_ctx.pagination.currentPage != 0)
                          ? (_openBlock(), _createBlock(_component_Paginator, {
                              key: 0,
                              first: _ctx.paginator,
                              pageLinkSize: 3,
                              rows: _ctx.pagination.itemsPerPage,
                              totalRecords: _ctx.pagination.totalItems,
                              onPage: _cache[6] || (_cache[6] = ($event: any) => (_ctx.find($event.page + 1)))
                            }, null, 8, ["first", "rows", "totalRecords"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("table", _hoisted_30, [
                          _createElementVNode("thead", _hoisted_31, [
                            _createElementVNode("tr", null, [
                              _hoisted_32,
                              _createElementVNode("th", {
                                style: {"width":"25%","cursor":"pointer"},
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.sort('x.employee.name')))
                              }, [
                                _createTextVNode("Name "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.employee.name' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _createElementVNode("th", {
                                style: {"width":"25%","cursor":"pointer"},
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.sort('x.employee.emailAddress')))
                              }, [
                                _createTextVNode("Email Address "),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["pi", [_ctx.sortingModel.columnName == 'x.employee.emailAddress' ? (_ctx.sortingModel.isAscending ? 'pi-sort-amount-up-alt' : 'pi-sort-amount-down') : 'pi-fw pi-sort-alt']])
                                }, null, 2)
                              ]),
                              _hoisted_33,
                              _hoisted_34,
                              _hoisted_35
                            ])
                          ]),
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("tbody", _hoisted_36, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination.users, (user, index) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                    _createElementVNode("td", {
                                      onClick: ($event: any) => (_ctx.view(user))
                                    }, _toDisplayString(((_ctx.pagination.currentPage - 1) * _ctx.pagination.itemsPerPage) + index + 1), 9, _hoisted_37),
                                    _createElementVNode("td", {
                                      onClick: ($event: any) => (_ctx.view(user))
                                    }, _toDisplayString(user.name), 9, _hoisted_38),
                                    _createElementVNode("td", {
                                      onClick: ($event: any) => (_ctx.view(user))
                                    }, _toDisplayString(user.emailAddress), 9, _hoisted_39),
                                    _createElementVNode("td", {
                                      onClick: ($event: any) => (_ctx.view(user))
                                    }, _toDisplayString(user.userRoles), 9, _hoisted_40),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createVNode(_component_Badge, {
                                          class: _normalizeClass(["mr-2", [user.status == 'Active' ? 'p-badge-success' : 'p-badge-danger']]),
                                          value: user.status
                                        }, null, 8, ["class", "value"])
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      (user.failedLoginCount >= 3)
                                        ? (_openBlock(), _createBlock(_component_Button, {
                                            key: 0,
                                            icon: "pi pi-unlock text-danger",
                                            title: "Unlock Account",
                                            severity: "danger",
                                            text: "",
                                            rounded: "",
                                            onClick: ($event: any) => (_ctx.unlock(user.identifier))
                                          }, null, 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (!_ctx.isLoading && _ctx.pagination.users.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                            _createVNode(_component_FontAwesomeIcon, {
                              icon: ['fas', 'image'],
                              size: "2x"
                            }),
                            _hoisted_43
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 1 }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_TheInvalidImportDialog, {
                title: "Employee",
                visible: _ctx.isDialogVisible,
                data: _ctx.invalidData,
                onCloseDialogEvent: _ctx.closeDialog,
                onProceedImportEvent: _ctx.proceedImport
              }, null, 8, ["visible", "data", "onCloseDialogEvent", "onProceedImportEvent"]),
              (_ctx.pageError != '')
                ? (_openBlock(), _createBlock(_component_ThePageError, {
                    key: 1,
                    onBackEvent: _ctx.cancel,
                    pageError: _ctx.pageError
                  }, null, 8, ["onBackEvent", "pageError"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ])
  ], 64))
}